// Initialize and add the map
function initMap() {
    if (!document.getElementById("map_eke")) return;
    const mapEl = document.getElementById("map_eke");
    // Ekenäs location.
    const ekenas = { lat: 59.975128, lng: 23.436904 };

    // The map, centered at Ekenäs
    const map = new google.maps.Map(mapEl, {
        mapId: "f4513de7d1f5c654",
        zoom: 18,
        center: ekenas,
        disableDefaultUI: true,
        zoomControl: true,
        });
 // The marker, positioned at Ekenäs
 const marker = new google.maps.Marker({
    position: ekenas,
    map: map,
    title: "Wi-Box Cafe",
    icon: {
      path: "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z",
      anchor: new google.maps.Point(15,15),
      fillColor: "#DCE2D6",
      fillOpacity: 1,
      strokeWeight: 1,
      strokeColor: "#4F7353",
      scale: 2,
      labelOrigin: new google.maps.Point(15,15),
    },
  });

  }

  window.initMap = initMap;
  
  window.addEventListener("load", () => {
    if (!document.getElementById("map_eke")) return;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDQ1dm8sSFRV6poh--gksavBK6H2qd6ofU&callback=initMap&v=weekly";
    script.defer = true;
    const head = document.querySelector("head");
    if (!head) return;
    head.append(script);
  });
  